export default function verifyEmptyValues(value) {
  return value ? value : '-----';
}
